const machineKey = (task) => {
    return (task.machine && typeof task.machine === "object" ? task.machine.id : task.machine) ?? null
}

// Une mise à jour socket recrée tous les objets tâche de la machine : comparer par valeur les seuls champs affichés
// évite de re-rendre les 200 lignes d'une file quand une seule tâche change.
export const isSameTaskDisplay = (previous, next) => {
    return previous === next || (
        previous.id === next.id
        && previous.fileName === next.fileName
        && previous.referer === next.referer
        && previous.previewUrl === next.previewUrl
        && machineKey(previous) === machineKey(next)
        && previous.machine?.number === next.machine?.number
    )
}

export const areTaskItemPropsEqual = (previous, next) => {
    return isSameTaskDisplay(previous.task, next.task)
        && previous.showMachine === next.showMachine
        && previous.toDeletedTasks === next.toDeletedTasks
        && previous.onSetFirstPosition === next.onSetFirstPosition
        && previous.onPreviewFileTask === next.onPreviewFileTask
        && previous.onTaskSended === next.onTaskSended
        && previous.onRemoveTask === next.onRemoveTask
}
